import { TOGGLE_ITINERARY_MODE } from "./itineraryModeReducer"

export const toggleItineraryMode = (value) => ({
    type: TOGGLE_ITINERARY_MODE,
    payload: value
})